// extracted by mini-css-extract-plugin
export var amountPaidColumn = "_h4-7";
export var emphasizeQuantity = "_h4-3";
export var flatBottomCorners = "_h4-5";
export var productImage = "_h4-0";
export var quantityContainer = "_h4-2";
export var quantityHeader = "_h4-6";
export var tooltip = "_h4-1";
export var wrapAndEllipsesOverflow = "_h4-4";